var _desc, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClearText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/clear-text") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/clear-text",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,0 C18.627417,0 24,5.372583 24,12 C24,18.627417 18.627417,24 12,24 C5.372583,24 0,18.627417 0,12 C0,5.372583 5.372583,0 12,0 Z M15.6735915,7.10416016 L12,10.7777516 L8.32640853,7.10416016 C7.99385538,6.77160701 7.45172739,6.77028565 7.11816799,7.10384505 L7.10384505,7.11816799 C6.77113886,7.45087418 6.77042673,7.9926751 7.10416016,8.32640853 L10.7777516,12 L7.10416016,15.6735915 C6.77160701,16.0061446 6.77028565,16.5482726 7.10384505,16.881832 L7.11816799,16.8961549 C7.45087418,17.2288611 7.9926751,17.2295733 8.32640853,16.8958398 L12,13.2222484 L15.6735915,16.8958398 C16.0061446,17.228393 16.5482726,17.2297143 16.881832,16.8961549 L16.8961549,16.881832 C17.2288611,16.5491258 17.2295733,16.0073249 16.8958398,15.6735915 L13.2222484,12 L16.8958398,8.32640853 C17.228393,7.99385538 17.2297143,7.45172739 16.8961549,7.11816799 L16.881832,7.10384505 C16.5491258,6.77113886 16.0073249,6.77042673 15.6735915,7.10416016 Z",
    id: "Combined-Shape",
    fill: "#B6BEBF"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearText);
export default __webpack_public_path__ + "static/media/clear-text.285e413a.svg";
export { ForwardRef as ReactComponent };